import { inject } from "../../../../../lib/itn-ui-kit/services/service-container";

export function useNotePermissions(noteObj) {
  const currentUserService = inject("current-user-service");
  const permissions = currentUserService?.userRoles?.permissions ?? [];

  const canAddCaseNotes = permissions.includes("casemanager.add_casenotes");
  const canEditCaseNotes = permissions.includes("casemanager.change_casenotes") && noteObj?.canEdit;

  const canSeeAISummary = permissions.includes("call_log.view_callsummary");

  return {
    canAddCaseNotes,
    canEditCaseNotes,
    canSeeAISummary,
  };
}
